// Import the functions you need from the SDKs you need
// import { initializeApp } from 'firebase/app';
// import firebase from 'firebase';
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration

// // Initialize Firebase

import { initializeApp } from 'firebase/app';
// import firebase from 'firebase/app';
import { getStorage } from 'firebase/storage';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore/lite';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
  authDomain: process.env.REACT_FIREBASE_AUTHDOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
  storageBucket: process.env.REACT_APP_FIREBASE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDERID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENTID,
};

// const firebaseConfig = {
//   apiKey: 'AIzaSyA8mRrN8nWILPzJADM1ppY-kWxd1ZIWijI',
//   authDomain: 'ebullion-qa-b9bbb.firebaseapp.com',
//   projectId: 'ebullion-qa-b9bbb',
//   storageBucket: 'ebullion-qa-b9bbb.appspot.com',
//   messagingSenderId: '675342229392',
//   appId: '1:675342229392:web:953a780ac66018db631d15',
//   measurementId: 'G-MRLMW3J88N',
// };

// firebase.initializeApp(firebaseConfig);
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth();
const storage = getStorage(app);
// const messaging = firebase.messaging();
//const provider=new GoogleAuthProvider()

export { db, auth, storage, app };
